<template>
  <div>
    <header class="cookie-banner__header">
      <h2>Wir verwenden Cookies</h2>
    </header>

    <p>
      Teach Economy ist eine Plattform, die es sich zur Aufgabe gemacht hat, hochwertiges
      Unterrichtsmaterial kostenlos anzubieten. Nach Ihrer Zustimmung platzieren wir einige
      wenige Cookies, die wir benötigen, um die Sicherheit und die Funktionen der Website
      gewährleisten und verbessern zu können. Ihre Einwilligung können Sie jederzeit widerrufen.
    </p>
    <p>
      Das Analysetool Matomo nutzen wir, um die Inhalte an den Interessen der Nutzer:innen
      auszurichten und weiterzuentwickeln. Die Informationen werden anonymisiert aufgenommen
      und zu keinem Zeitpunkt an Dritte weitergegeben. Da wir keinerlei kommerzielle Zwecke
      verfolgen, unser Angebot für Sie aber stetig verbessern wollen, bitten wir Sie, alle
      Cookies zu akzeptieren. Unter „Anpassen“ haben Sie die Möglichkeit, eine Auswahl zu
      treffen.
    </p>

    <footer>
      <button
        class="button"
        @click="acceptAll"
      >
        Akzeptiere alle
      </button>

      <button
        class="button"
        @click="setRoute('settings')"
      >
        Anpassen
      </button>
    </footer>
  </div>
</template>

<script>
import EventBus from '../functions/event-bus.js'

export default {
  name: 'VInfo',

  methods: {
    acceptAll () {
      EventBus.emit('accept-all')
    },
    setRoute (name) {
      EventBus.emit('route', name)
    }
  }
}
</script>
